import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import { useCookies } from 'react-cookie';
import { navigate } from '@gatsbyjs/reach-router';

// Components
import GatsbyHead from '../../components/layout/gatsby-head';
import Layout from '../../components/layout/root-layout';
import { Container } from '../../components/layout';
import Assemblies from '../../components/assemblies';
import withSplitTest from '../../components/with-split-test';

// Utils
import { extractLayoutProps } from '../../utils/layout';
import { useSiteConfig } from '../../hooks/site-config';

// Styles
import {
  AssemblyWrapper,
  StyledCTA,
  StyledArticle,
  CTAWrapper,
  Logo,
  LogoWrapper,
  StyledRichText,
} from './styles';

export const Head = ({ data }) => <GatsbyHead pageContent={data.page} />;

const SplashPage = ({ data }) => {
  const { page } = data;

  const { bodyCopy, subText, assemblies } = page;
  const [cookie, setCookie] = useCookies(['domain']);
  const { logo } = useSiteConfig();

  return (
    <Layout {...extractLayoutProps(page, data.contentfulConfig)}>
      {logo && (
        <LogoWrapper>
          <Logo src={logo.file.url} cacheRequests />
        </LogoWrapper>
      )}

      <Container>
        <StyledArticle>
          {bodyCopy && <StyledRichText richText={bodyCopy} />}

          <CTAWrapper>
            <StyledCTA
              bg="secondary-standard"
              link={{
                external: true,
                URL: 'https://england.shelter.org.uk',
                newTab: false,
              }}
            >
              England
            </StyledCTA>
            <StyledCTA
              bg="secondary-standard"
              link={{
                external: true,
                URL: 'https://scotland.shelter.org.uk',
                newTab: false,
              }}
            >
              Scotland
            </StyledCTA>
            <StyledCTA
              bg="secondary-outline"
              link={{
                external: true,
                URL: 'https://sheltercymru.org.uk/',
                newTab: false,
              }}
            >
              Wales
            </StyledCTA>
            <StyledCTA
              bg="secondary-outline"
              link={{
                external: true,
                URL: 'https://www.housingadviceni.org/',
                newTab: false,
              }}
            >
              Northern Ireland
            </StyledCTA>
          </CTAWrapper>
          {subText && <StyledRichText richText={subText} />}
        </StyledArticle>
      </Container>

      <AssemblyWrapper>
        <Assemblies assemblies={assemblies} />
      </AssemblyWrapper>
    </Layout>
  );
};

SplashPage.propTypes = {
  data: PropTypes.shape({
    page: PropTypes.object,
    contentfulConfig: PropTypes.object,
  }),
  pageContext: PropTypes.object,
};

export default withSplitTest(SplashPage);

export const SplashPageTemplateQuery = graphql`
  query SplashPageTemplateQuery {
    page: contentfulPageSplash {
      ...PageSplashFragment
    }
    ...NavigationFragment
  }
`;
